import { East } from '@mui/icons-material';
import { Box, Grid, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledDatePicker from 'src/shared/components/form/controlledDatePicker';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { CurrencyEnum } from 'src/shared/models/enums/currency.enum';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';

export const GiftAdvancedSearchSection = () => {
  const { t } = useTranslation();
  const { currentUser } = useGlobals();

  const currency = getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.Currency, CurrencyEnum.SEK);

  return (
    <Box mt={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <ControlledDatePicker label={t('gift:dateFrom')} name='dateFrom' />
        </Grid>
        <Grid item xs={12} sm={3}>
          <ControlledDatePicker label={t('gift:dateTo')} name='dateTo' />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container textAlign='center' display='flex' justifyContent='space-between'>
            <Grid item xs={12} sm={5.5}>
              <ControlledTextField
                name='minAmount'
                label={t('gift:amountFrom')}
                type='number'
                bgcolor='white'
                inputProps={{
                  min: 0,
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                InputProps={{
                  endAdornment: <InputAdornment position='end'>{currency}</InputAdornment>,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <East sx={{ color: (thm) => thm.palette.grey[400], mt: 1 }} />
            </Grid>

            <Grid item xs={12} sm={5.5}>
              <ControlledTextField
                name='maxAmount'
                label={t('gift:amountTo')}
                type='number'
                bgcolor='white'
                inputProps={{
                  min: 0,
                }}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                InputProps={{
                  endAdornment: <InputAdornment position='end'>{currency}</InputAdornment>,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
